import React from 'react';
import { items10 } from '../lib/faker';
import { Box, Flex } from './../components/layout/Grid';
import BaseSkeleton from './BaseSkeleton';

const CollectionRowSkeleton = props => (
  <React.Fragment>
    <Box mb={20}>
      <BaseSkeleton
        shape={'square'}
        height={30}
        width={40}
        animation={props.animation}
      />
    </Box>
    <Flex flexWrap="wrap" mx="-15px" mb="20px">
      {items10.map((item, index) => {
        let mb = index % 5 === 0 ? 20 : 0;
        return (
          <Box key={index} width={[1, 1, 1 / 5]} mb={[20, 20, mb]} px="15px">
            <BaseSkeleton
              height={300}
              width={100}
              animation={props.animation}
            />
          </Box>
        );
      })}
    </Flex>
  </React.Fragment>
);

export default CollectionRowSkeleton;
